import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'requestIssue',
})
export class RequestIssuePipe implements PipeTransform {
    transform(value: number, year: string) {
        if (value == null) {
            return '';
        }
        if (!year) {
            return '' + value;
        }

        const valuestr = value < 1000 ? ('000' + value).slice(-3) : '' + value;

        return `${year.substr(2, 2)}${year.substr(6, 2)}-${valuestr}`;
    }
}
